import React, { useState } from "react";
import { GraphsScreen } from "./graphs/Graphs";
import { MapScreen } from "./heatmap/Map";
import { About } from "./about/About";
import { Timeline } from "./timeline/Timeline";
import { Navbar } from "../components/Navbar";
import { GameScreen } from "./game/Game";
import InactivityCheck from "../components/InactivityPopup/InactivityCheck";
import { ISO } from "./iso/ISO";

// array of info about screens for easy rendering using Screens.map()
export const Screens = [
  {
    name: "map",
    title: "Campus Energy Map",
    component: <MapScreen />,
  },
  {
    name: "graphs",
    title: "Campus Energy Data",
    component: <GraphsScreen />,
  },
  {
    name: "iso-ne",
    title: "Regional Energy Data",
    component: <ISO />,
  },
  {
    name: "timeline",
    title: "Dartmouth Energy History",
    component: <Timeline />,
  },
  {
    name: "game",
    title: "Test Your Knowledge",
    // component: <GameScreen selectTab={null} />,
  },
  {
    name: "about",
    title: "About the Kiosk",
    component: <About />,
  },
];

const Main: React.FC = () => {
  // index of tab that is currently selected
  const [selectedTab, selectTab] = useState(0);
  document.addEventListener("contextmenu", (event) => event.preventDefault());

  return (
    <div
      className="expand"
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-end",
      }}
    >
      <div
        style={{
          flexGrow: 1,
          position: "relative",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <div
          style={{
            position: "absolute",
            zIndex: 1,
          }}
        >
          <InactivityCheck selectTab={selectTab} />
        </div>
        {selectedTab == 4 ? (
          <GameScreen selectTab={selectTab} />
        ) : (
          Screens[selectedTab].component
        )}
      </div>

      <Navbar selectedTab={selectedTab} selectTab={selectTab} />
    </div>
  );
};

export default Main;
